module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "secondComponent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "id": "jack",
      "value": "Jack"
    },
    domProps: {
      "value": "Jack",
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "Jack") > -1 : _vm._q(_vm.checkedNames, true)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Jack",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "jack"
    }
  }, [_vm._v("Jack")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "id": "john",
      "value": "John"
    },
    domProps: {
      "value": "John",
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "John") > -1 : _vm._q(_vm.checkedNames, true)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "John",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "john"
    }
  }, [_vm._v("John")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "id": "mike",
      "value": "Mike"
    },
    domProps: {
      "value": "Mike",
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "Mike") > -1 : _vm._q(_vm.checkedNames, true)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Mike",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "mike"
    }
  }, [_vm._v("Mike")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Checked names: " + _vm._s(_vm.checkedNames))]), _vm._v(" "), _c('div', [_c('h2', [_vm._v("All Tasks")]), _vm._v(" "), _c('ul', _vm._l((_vm.tasks), function(task) {
    return _c('li', {
      domProps: {
        "textContent": _vm._s(task.description)
      }
    })
  })), _vm._v(" "), _c('h2', [_vm._v("inncompleted Tasks")]), _vm._v(" "), _c('ul', _vm._l((_vm.inncompletedTasks), function(task) {
    return _c('li', {
      domProps: {
        "textContent": _vm._s(task.description)
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a60d9920"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/secondComponent.vue
// module id = 25
// module chunks = 0